import QuestionInputSelect from "./QuestionInputSelect";
import GelHackButton from "../gel/GelHackButton";
import common from "../../common";
import GelHackToggleButton from "../gel/GelHackToggleButton";
import GelButton from "../gel/GelButton";

export default class QuestionInputSelectVisual extends QuestionInputSelect {
    constructor(question, view) {
        super(question, view);
    }

    selectOption(option) {
        super.selectOption(option);

        option.toggle = true;
        //option.image.alpha = 0.5;
        //option.image.tint = 0x00FF00;
        //option.image.tint = 0x067955;
        option.image.tint = 0x097050;
    }

    deselectOption(option) {
        super.selectOption(option);

        option.toggle = false;
        option.image.alpha = 1;
        option.image.tint = 0xFFFFFF;
    }

    createOptionButtons(options) {
        this._buttonsContainer = new PIXI.Container();
        this.addChild(this._buttonsContainer);

        // minimum font size
        this._fontSize = this.calculateFontSize(options);

        for (let i = 0; i < options.length; ++i) {
            const button = this.createOptionButton(options[i]);
            button.index = i;
            button.position.set(this._spacing * i - (this._spacing * (options.length - 1)) * 0.5, 0);
            button.tabIndex = GelButton.TAB_INDEX_LEVEL_1 + i;
            button.signals.down.add(this.onOptionButtonDown, this);
            button.signals.up.add(this.onOptionButtonUp, this);
            button.signals.click.add(this.onOptionButtonClick, this);

            const buttonBack = new PIXI.Sprite(P3.assets.texture("ui_drop_in_answerbox"));
            buttonBack.anchor.set(0.5);
            buttonBack.position.set(button.x, button.y);
            //this._buttonsContainer.addChildAt(buttonBack, 0);
            this._buttonsContainer.addChild(button);
            this._buttons.push(button);
        }
    }

    createOptionButton(value) {
        const a = P3.assets;

        const buttonStates = new P3.ButtonStates();
        buttonStates.normal = PIXI.Texture.EMPTY;// a.texture("ui_drop_in_area");
        buttonStates.normalAlt = PIXI.Texture.EMPTY;//a.texture("ui_drop_in_area_selected");
        buttonStates.over = PIXI.Texture.EMPTY;//a.texture("ui_drop_in_area_highlight");
        buttonStates.over = PIXI.Texture.EMPTY;//a.texture("ui_drop_in_area_selected");

        const button = !PIXI.utils.isMobile.any ?
            new GelHackToggleButton(buttonStates) :
            new P3.ToggleButton(buttonStates);

        button.value = value;
        button.animate = false;
        button.animateIcon = false;
        button.tint = common.config.debug && button.value === this._question.answer ? 0x00AA00 : 0xFFFFFF;

        button.image = new PIXI.Sprite(P3.assets.texture(value.texture));
        button.image.anchor.set(0.5);
        button.image.scale.set(0.4);
        value.hasOwnProperty('rotation') && (button.image.rotation = value.rotation * PIXI.DEG_TO_RAD);
        button.animation.addChild(button.image);

        return button;
    }
}